<app-loader></app-loader>
  <div>
    <div class="modal-header">
      <h4 class="modal-title pull-left">
        <i class="fa fa-file-text"></i>{{model.code}}
      </h4>
      <i
        class="fa fa-close popup-close small"
        aria-hidden="true"
        title="Close"
        (click)="modalRef.hide()"
      ></i>
    </div>
  
    <div class="modal-body">
      <div class="row">
        <div class="form-group col-lg-6 col-md-6 col-sm-12">
          <label class="label-font" for="code">Customer Code</label>
          <div class="info">{{model.code}}</div>
        </div>
        <div class="form-group col-lg-6 col-md-6 col-sm-12">
          <label class="label-font" for="code">License Type</label>
          <div class="info">{{model.licenseType}}</div>
        </div>
      </div>
      
      <div class="row">
        <div class="form-group col-lg-6 col-md-6 col-sm-12">
          <label class="label-font" for="code">Assigned Utilities</label>
          <div class="info" *ngFor="let utility of model.utilityList">{{utility}}</div>
        </div>
        <div class="form-group col-lg-6 col-md-6 col-sm-12">
          <label class="label-font" for="code">License Period</label>
          <div class="info">{{model.startDate}} - {{model.endDate}}</div>
        </div>
      </div>

      <div class="row">
        <div class="form-group col-lg-6 col-md-6 col-sm-12">
          <label class="label-font" for="code">User Count</label>
          <div class="info">{{model.userCount}}</div>
        </div>
        <div class="form-group col-lg-6 col-md-6 col-sm-12">
          <label class="label-font" for="code">Total Cost</label>
          <div class="info">{{model.totalCost}}</div>
        </div>
      </div>

    </div>
  
   
  </div>